export default "__VITE_ASSET__CKgBX2SE__"